import Tooltip from './Tooltip';

const FieldWithTooltip = ({ label, tooltip, children, className = '' }) => (
  <div className={`input-container ${className}`}>
    <label className="input-label">
      {label} <Tooltip description={tooltip} />
    </label>
    {children}
  </div>
);

export default FieldWithTooltip;
